
<div class="navbar-open" *ngIf="type == 'left'" ngClass="{{ data.customClass }}" #popup>
      <nav ngClass="{{ sidebarOpen ? 'adc-sidebar adc-sidebar2' : 'adc-sidebar' }}" class="adc-d-flex adc-flex-column adc-justify-content-between">
        <ul class="adc-list adc-noborder-list">
            <li class="adc-sidenav-list-item" *ngFor="let i of data.items" title="{{i.itemLabel | translate}}" (click)="navigateTo(i)" [ngClass]="i.itemId == activeId ? 'sidenav-active' : 'non-active'">
                <div class="adc-d-flex adc-gap-3">
                    <img src="{{ i.itemIcon }}" alt="home">
                    <span class="adc-truncate" *ngIf="sidebarOpen">{{i.itemLabel | translate}}</span>
                </div>
            </li>
        </ul>
        <ul class="adc-list adc-noborder-list">
            <li class="adc-sidenav-list-item" *ngFor="let i of data.bottomList" title="{{i.itemLabel | translate}}" (click)="navigateTo(i)" [ngClass]="i.itemId == activeId ? 'sidenav-active' : 'non-active'">
                <div class="adc-d-flex adc-gap-3">
                    <img src="{{ i.itemIcon }}" alt="home">
                    <span class="adc-truncate" *ngIf="sidebarOpen">{{i.itemLabel | translate}}</span>
                </div>
            </li>
        </ul>
      </nav>
      <div class="popup" [ngStyle]="{'left': sidebarOpen ? '13.6rem' : '3.125rem'}" *ngIf="secondLevelMenuId === activeId">
        <ng-content></ng-content>
      </div>
</div>


<div class="navbar-open" *ngIf="type == 'menu'" ngClass="{{ data.customClass }}" #popup>
    <nav ngClass="{{ sidebarOpen ? 'adc-sidebar adc-sidebar2' : 'adc-sidebar' }}" class="adc-d-flex adc-flex-column adc-justify-content-between">
        <ul class="adc-list adc-noborder-list">
            <div class="" *ngFor="let i of data.items; let index = index;">
                <li class="adc-h-30px adc-d-flex adc-cursor-pointer adc-sidenav-list-item adc-justify-content-between adc-align-items-center" [ngClass]="url === i.path ? 'sidenav-active' : 'non-active'" title="{{i.itemLabel | translate}}" (click)="handleparentClick(i)">
                    <div class="adc-d-flex adc-align-items-center adc-gap-3 icon">
                        <!-- <img src="{{ i.itemIcon }}" alt="home"> -->
                        <span class="material-symbols-outlined">{{i.itemIcon}}</span>
                        <span class="adc-m0 adc-truncate" *ngIf="sidebarOpen" [ngClass]="isChildrenOpened(i.itemId) ? 'adc-f-bold' : ''">{{i.itemLabel | translate}}</span>
                    </div>
                    <div *ngIf="i.children">
                        <svg class="adc-mt5" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff" *ngIf="!isChildrenOpened(i.itemId) && sidebarOpen">
                            <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                        </svg>
                        <svg class="adc-mt5" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed" *ngIf="isChildrenOpened(i.itemId) && sidebarOpen">
                            <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/>
                        </svg>
                    </div>
                    <!-- <div class="highlight" *ngIf="i.itemId == activeId2 && i.children && !sidebarOpen"></div> -->
                </li>
                <div *ngIf="sidebarOpen && i.itemId == activeId2">
                    <li class="adc-ml10 adc-list-none display-block adc-mt10 adc-pr0 adc-sidenav-list-item" *ngFor="let item of i.children" title="{{item.itemLabel | translate}}" [ngClass]="[item.itemId == childActiveId && !item.children ? 'sidenav-active' : 'non-active', item.children ? 'style-none' : '']">
                        <div class="adc-d-flex adc-justify-content-between adc-align-items-center" (click)="handleClick(item)">
                            <div class="adc-d-flex adc-gap-3">
                                <!-- <img src="{{ item.itemIcon }}" alt="home"> -->
                                <span class="material-symbols-outlined">{{item.itemIcon}}</span>
                                <span class="adc-truncate" [ngClass]="isGrandChildrenOpened(item.itemId) && item.children ? 'adc-f-bold' : ''">{{ item.itemLabel | translate}}</span>
                            </div>
                            <div *ngIf="item.children">
                                <svg class="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff" *ngIf="!isGrandChildrenOpened(item.itemId) && sidebarOpen">
                                    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                                </svg>
                                <svg class="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed" *ngIf="isGrandChildrenOpened(item.itemId) && sidebarOpen">
                                    <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/>
                                </svg>
                            </div> 
                        </div>
                        <div *ngIf="sidebarOpen && item.itemId == childActiveId">
                            <li class="adc-ml10 adc-list-none display-block adc-mt10 adc-pr0 adc-sidenav-list-item" *ngFor="let child of item.children" title="{{child.itemLabel | translate}}" [ngClass]="[child.itemId == grandChildActiveId && !child.children ? 'sidenav-active' : 'non-active', child.children ? 'style-none' : '']">
                                <div class="adc-d-flex adc-justify-content-between adc-align-items-center" (click)="handleGrandChildClick(child)">
                                    <div class="adc-d-flex adc-gap-3">
                                        <!-- <img src="{{ child.itemIcon }}" alt="home"> -->
                                        <span class="material-symbols-outlined">{{child.itemIcon}}</span>
                                        <span class="adc-truncate">{{ child.itemLabel | translate}}</span>
                                    </div>
                                    <div *ngIf="child.children">
                                        <svg class="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff" *ngIf="!isThirdLevelChildrenOpened(item.itemId) && sidebarOpen">
                                            <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                                        </svg>
                                        <svg class="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed" *ngIf="isThirdLevelChildrenOpened(item.itemId) && sidebarOpen">
                                            <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div *ngIf="sidebarOpen && child.itemId == grandChildActiveId">
                                    <li class="aadc-ml10 adc-list-none display-block adc-mt10 adc-pr0 adc-sidenav-list-item" *ngFor="let childItem of child.children" (click)="navigateThirdLevelChildTo(childItem)" title="{{childItem.itemLabel | translate}}" [ngClass]="[childItem.itemId == thirdLevelActiveId ? 'sidenav-active' : 'non-active', childItem.children ? 'style-none' : '']">
                                        <div class="adc-d-flex adc-gap-3">
                                            <!-- <img src="{{ childItem.itemIcon }}" alt="home"> -->
                                            <span class="material-symbols-outlined">{{childItem.itemIcon}}</span>
                                            <span class="adc-truncate">{{ childItem.itemLabel | translate}}</span>
                                        </div>
                                    </li>
                                </div>
                            </li>
                        </div>
                    </li>
                </div>
            </div>
        </ul>
        <ul class="adc-list adc-noborder-list">
            <li class="adc-sidenav-list-item" *ngFor="let i of data.bottomList" title="{{i.itemLabel | translate}}" (click)="navigateTo2(i)" [ngClass]="i.itemId == activeId2 ? 'sidenav-active' : 'non-active'">
                <div class="adc-d-flex adc-gap-3">
                    <!-- <img src="{{ i.itemIcon }}" alt="home"> -->
                    <span class="material-symbols-outlined">{{i.itemIcon}}</span>
                    <span class="adc-truncate" *ngIf="sidebarOpen">{{i.itemLabel | translate}}</span>
                </div>
            </li>
        </ul>
    </nav>
    <div class="popup" [ngStyle]="{'left': sidebarOpen ? '13.6rem' : '3.125rem'}" *ngIf="subMenuId.includes(activeId2) || subMenuId.includes(childActiveId) || subMenuId.includes(grandChildActiveId)">
        <ng-content></ng-content>
    </div>
</div>



<!-- <div class="navbar-open adc-ml50" *ngIf="type == 'right'" ngClass="{{ data.customClass }}">
    <div ngClass="{{ rightSidebarOpen ? 'img-div2' : 'img-div' }}">
        <img src="../../../assets/logo-200x65-white.png" alt="Aithent Logo" style="width: 100px; height: 30px; padding: 10px;" *ngIf="rightSidebarOpen">
        <img src="../../../assets/icons/three.png" alt="toggle" style="width: 30px; height: 30px; position: absolute; right: 0px;" class="adc-pl10 adc-pt10 adc-mr10 adc-cursor-pointer" (click)="rightSidebarToggle()">
    </div>
    <nav ngClass="{{ rightSidebarOpen ? 'adc-sidebar adc-sidebar2' : 'adc-sidebar' }}" style="height: auto;">
        <div class="adc-p15">
            <ul class="rightNavItem" *ngFor="let i of data.items">
                <li><span class="adc-sidebar-text" *ngIf="rightSidebarOpen">{{i.itemLabel}}</span></li>
                <mat-icon>{{i.itemIcon}}</mat-icon>
            </ul>
        </div>
    </nav>
</div> -->